// extracted by mini-css-extract-plugin
module.exports = {"rooms":"rooms-module--rooms--2FOBo","rooms__imageButton":"rooms-module--rooms__image-button---heAu","rooms__imageButtonWrap":"rooms-module--rooms__image-button-wrap--ftpcf"};